import { combineReducers } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

import bookReducer from './Redux/bookReducer';
import chapterReducer from './Redux/chapterReducer';
import verseReducer from './Redux/verseReducer';
import dialog2Reducer from './Redux/dialog2Reducer';
import dialog4Reducer from './Redux/dialog4Reducer';
import verseSearchReducer from './Redux/verseSearchReducer';
import homeReducer from './Redux/homeReducer';
import switch1Reducer from './Redux/switch1Reducer';
import chipArrayReducer from './Redux/chipArrayReducer';
import verseLabelArrows4ResultReducer from './Redux/verseLabelArrows4ResultReducer';
import signInReducer from './Redux/signInReducer';
import fullFormatVerseReducer from './Redux/fullFormatVerseReducer';
import noteBookmarkVerseListReducer from './Redux/noteBookmarkVerseListReducer';
import noteBookmarkListReducer from './Redux/noteBookmarkListReducer';
import goToTopButtonReducer from './Redux/goToTopButtonReducer';
import confirmationDialogReducer from './Redux/confirmationDialogReducer';
import profileReducer from './Redux/profileReducer';
import noteSearchReducer from './Redux/noteSearchReducer';

const rootReducer = combineReducers({ // Combine all reducers
  book: bookReducer,
  chapter: chapterReducer,
  verse: verseReducer,
  dialog2: dialog2Reducer,
  dialog4: dialog4Reducer,
  verseSearch: verseSearchReducer,
  home: homeReducer,
  switch1: switch1Reducer,
  chipArray: chipArrayReducer,
  verseLabelArrows4Result: verseLabelArrows4ResultReducer,
  signIn: signInReducer,
  fullFormatVerse: fullFormatVerseReducer,
  noteBookmarkVerseList: noteBookmarkVerseListReducer,
  noteBookmarkList: noteBookmarkListReducer,
  goToTopButton: goToTopButtonReducer,
  confirmationDialog: confirmationDialogReducer,
  profile: profileReducer,
  noteSearch: noteSearchReducer,
});

const persistConfig = { // Persist configuration for the entire root reducer
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer); // Wrap the root reducer with persistReducer

const store = configureStore({ // Configure the store with the persisted reducer
  reducer: persistedReducer,
});

const persistor = persistStore(store); // Create the persistor

export { store, persistor };